// @ts-nocheck
import { CONFIG } from "~/config";
import MyMapsPopup from "~/es6/mymaps.popup";
import MyMapsShareFrame from "~/es6/mymaps.share.frame";
import { _ } from "~/i18n";
import MyMapsShareLinks from "~/es6/mymaps.share.links";
import { node, icon } from "~/util/dom";
import Scene from "~/scene";
import { updateMapyBoxItem } from "~/util/mapybox";

/**
 * Okno pro sdílení informací
 *
 * Signaly:
 * popup-close { public: {boolean} } posledni stav itemu
 */
export default class MyMapsShare {
	/**
	 * Konstruktor
	 * @param {Object} data Data z backendu
	 * @param {Function} cb Callback
	 * @param {String} [twitterText] Vlastni twitter text
	 */
	constructor(data, cb, twitterText?) {
		this._popup = new MyMapsPopup({
			name: "share",
			cb: cbData => this._popupEvent(cbData),
		});

		this._popup.closeButton.dataset.logIgnore = true;

		this._isActive = false;
		this._activeTab = "share";
		this._popup.getContainer().classList.add("inactive");

		this._shortFrameURL = "";
		this._titleType = "";

		this._dom = {
			switch: {
				container: node("div", { className: "switch-tab" }),
				share: node("span", { className: "share-switch active" }, _("action.share.shareTitle")),
				frame: node("span", { className: "share-switch" }, _("action.share.frameTitle")),
			},
			shared: {
				hint: node("div", { className: "share-hint" }),
				warning: node("div", { className: "warning" }),
				warningSw: node("div", { className: "warning-switch" }),
				labelShare: node("label", { className: "switch" }),
				labelShareSpan: node("span", { className: "share-with" }, _("mymap.share.shareWith", { name: "" })),
				inputShare: node("input", { type: "checkbox" }),
				slider: node("span", { className: "share-slider" }),
				swDiv: node("div", { className: "switch-container" }),
			},
		};

		// analytika tabu
		this._dom.switch.share.setAttribute("data-log-action", "click");
		this._dom.switch.frame.setAttribute("data-log-action", "click");

		this._data = null;
		this._cb = cb;
		this.data = data;

		this._dom.tabs = {
			share: this._share.container,
			frame: this._frame.container,
		};

		const frag = Mapy.Util.fragment();

		this._dom.switch.container.appendChild(this._dom.switch.share);

		if (!this._data.noFrame) {
			this._dom.switch.container.appendChild(this._dom.switch.frame);
			this._dom.switch.container.addEventListener("click", this, false);
		}
		frag.appendChild(this._dom.switch.container);
		frag.appendChild(this._dom.tabs.share);

		if (!this._data.noFrame) {
			frag.appendChild(this._dom.tabs.frame);
		}

		this._twitterText = twitterText;

		this._shared = false; //kliklo se na sdílecí tlačítko

		if (["places-root", "activities-root"].indexOf(this._data.type) > -1) {
			this._dom.shared.warning.appendChild(node("p", {}, _(`mymap.share.warning.${this._data.type}`)));
			this._dom.shared.warning.appendChild(node("p", { className: "note" }, _(`mymap.share.warningNote.${this._data.type}`)));

			const switchCon = node("p", {}, _("mymap.share.onlyMap"));

			switchCon.appendChild(icon("dropdown"));
			this._dom.shared.warningSw.appendChild(switchCon);

			this._dom.shared.warningSw.addEventListener("click", this, false);
		}

		this._dom.shared.inputShare.addEventListener("change", this, false);

		if (this._data.like) {
			this._dom.shared.labelShare.appendChild(this._dom.shared.inputShare);
			this._dom.shared.labelShare.appendChild(this._dom.shared.slider);
			this._dom.shared.labelShare.appendChild(this._dom.shared.labelShareSpan);
			this._dom.shared.swDiv.appendChild(this._dom.shared.labelShare);
			this._dom.shared.swDiv.appendChild(this._dom.shared.hint);
		}

		this._popup.getContainer().appendChild(frag);
	}

	/**
	 * Zrušení
	 */
	destroy() {
		Mapy.Util.clear(this._popup.getContainer());
		this._isActive = false;
		this._frame.destroy();

		if (Scene.isM3dActive()) {
			Scene.set3DInteraction();
		}
	}

	/**
	 * Otevře popup se sdílecím oknem
	 */
	open() {
		if (this._data && this._data.type) {
			Mapy.getComponent("history").save(true);
			this._setActive();
			this._popup.open();

			if (Scene.isM3dActive()) {
				Scene.set3DInteraction(false);
			}
		}
	}

	/**
	 * Zavře popup se sdílecím oknem
	 */
	close() {
		this._frame.close();
		this._popup.close();

		if (Scene.isM3dActive()) {
			Scene.set3DInteraction();
		}
	}

	/**
	 * Zachycení událostí
	 * @param {Event} event událost
	 */
	handleEvent(event) {
		const trg = event.target;

		switch (event.type) {
			case "change":
				this._publicChange(trg.checked);
				break;
			case "click":
				if (trg === this._dom.switch.share || trg === this._dom.switch.frame) {
					if (trg.classList.contains("active")) {
						return;
					}

					const pop = this._popup.getContainer();

					pop.removeAttribute("style");
					for (const item in this._dom.tabs) {
						if (item) {
							this._dom.tabs[item].classList.remove("active");
						}
					}

					for (const item in this._dom.switch) {
						if (item) {
							this._dom.switch[item].classList.remove("active");
							if (this._dom.switch[item] === trg) {
								this._frame.close();

								trg.classList.add("active");

								const newTab = this._dom.tabs[item];

								newTab.classList.add("active");
								this._activeTab = item;

								if (this._data.like) {
									newTab.insertBefore(this._dom.shared.swDiv, newTab.firstChild);
								}

								if (["places-root", "activities-root"].indexOf(this._data.type) > -1) {
									if (this._dom.shared.warningSw.classList.contains("show")) {
										newTab.insertBefore(this._dom.shared.warningSw, newTab.firstChild);
										newTab.insertBefore(this._dom.shared.warning, newTab.firstChild);
									} else {
										newTab.appendChild(this._dom.shared.warning);
										newTab.appendChild(this._dom.shared.warningSw);
									}
								}

								if (item === "frame") {
									if (this._shortFrameURL) {
										this._frame.link = this._shortFrameURL;
									} else {
										this.setShortFrameLink();
									}
								}
							}
						}
					}

					if (this._data.like) {
						this._setHint();
					}
				} else if (this._isActive) {
					if (trg === this._dom.shared.warningSw || this._dom.shared.warningSw.contains(trg)) {
						this._switchShare();
					}
				} else {
					event.preventDefault();
				}
				break;
			default:
				break;
		}
	}

	/**
	 * Nastaví data pro sdílecí okno
	 * @param {Object} data Data z backendu
	 */
	set data(data) {
		this._data = {
			type: "", // složku, trasu... co sdílet
			title: "", // jak se to jmenuje
			public: false, //je již veřejná?,
			like: false, // oblibena z moje mapy?
			...data,
		};

		switch (this._data.type) {
			case "folder":
				this._titleType = "folder";
				break;

			case "track":
				this._titleType = "track";
				break;

			case "link":
			case "point":
			case "entity":
			case "measure":
			case "path":
			case "set":
			case "route":
			case "activities-root":
			case "places-root":
				this._titleType = "item";
				break;

			default:
				break;
		}

		this._frame = new MyMapsShareFrame(this, this._data);
		this._share = new MyMapsShareLinks(this, this._data, this._twitterText);

		if (this._data.like) {
			this._setHint();
			if (this._data.public) {
				this._dom.shared.inputShare.checked = true;
				this._share.link = this._data.url;
				Mapy.Util.getShortLink(this._data.url).then(shortURL => {
					this._setActive();
					this._share.shortLink = shortURL.url;
				}).catch(() => {
					this._dom.shared.inputShare.checked = false;
					this._setActive();
					this._share.shortLink = "";
				});
			}
		} else {
			this._dom.shared.swDiv.remove();
			this._share.link = this._data.url;
			Mapy.Util.getShortLink(this._data.url).then(shortURL => {
				this._setActive();
				this._share.shortLink = shortURL.url;
			}, () => {});
		}

		this._share.titleType = this._titleType;
	}

	/**
	 * Nastaví, že byl odkaz sdílen
	 */
	set shared(shared) {
		this._shared = shared;
	}

	/**
	 * Vrátí, zda je sdílení aktivní
	 */
	get isActive() {
		return this._isActive;
	}

	/**
	 * Vrátí sdílené prvky DOMu
	 */
	get sharedDom() {
		return this._dom.shared;
	}

	/**
	 * Vrátí popup okno
	 */
	get popup() {
		return this._popup;
	}

	/**
	 * Aktivní tab
	 */
	get activeTab() {
		return this._activeTab;
	}

	/**
	 * Podle nastavení přepínače zajistí zaktivnění nebo deaktivaci ovládacích prvků.
	 */
	_setActive() {
		this._isActive = this._dom.shared.inputShare.checked || !this._data.like;
		this._popup.getContainer().classList[this._isActive ? "remove" : "add"]("inactive");
		this._dom.shared.swDiv.classList[this._isActive ? "remove" : "add"]("not-shared");

		this._frame.setActive();
		this._share.setActive();
	}

	/**
	 * Změna stavu checkboxu
	 *
	 * @param  {Boolean} state Stav checkboxu
	 */
	_publicChange(state) {
		if (this._data.id) {
			// request
			this._share.error = "";

			updateMapyBoxItem(this._data, {
				public: state,
			}).then(() => {
				this._setActive();
				this._loadLink();
				this.setShortFrameLink(this._activeTab !== "frame");
				Mapy.getComponent("logger").log(state ? "public-set" : "public-unset", {
					type: this._data.type,
					origin: this._data.id,
					...this._data.analytics ? this._data.analytics : {},
				});
				Mapy.getComponent("places").notifyLikeUpdate(this._data.id, { public: state });
				if (this._data.type === "folder") {
					Mapy.getComponent("places").loadList();
					Mapy.ProviderMapyBox.removeAllOtherFolderFromCache(this._data.id);
				}
				if ("public" in this._data) {
					this._data.public = state;
				}
			}, error => {
				// eslint-disable-next-line no-console
				console.error(error);
				this._share.error = _("mymap.share.publicError");
				this._dom.shared.inputShare.checked = false;
				this._share.shortLink = "";
				this._setActive();
				Mapy.getComponent("places").notifyLikeUpdate(this._data.id, { public: state });
			});
		} else {
			// bez requestu
			this._setActive();
			this._loadLink();
		}
	}

	/**
	 * Načtení linku pro sdílení
	 */
	_loadLink() {
		this._share.link = this._data.url;
		Mapy.Util.getShortLink(this._data.url).then(data => {
			this._share.shortLink = data.url;
		}, () => {
			this._dom.shared.inputShare.checked = false;
			this._share.shortLink = "";
			this._setActive();
		});
	}

	/**
	 * Nastaví krátký link pro iframe
	 * @param {Boolean} [dontActivate = false] Neaktivovat?
	 * @param {Object} [options] Dalsi mozna nastaveni
	 */
	setShortFrameLink(dontActivate = false, options = {}) {
		const history = Mapy.getComponent("history");
		const state = JSON.parse(JSON.stringify(history.state));

		delete state.active;

		// pokud mame ve stateu detail, nechceme prenaset hledani do iframu
		if (state.q && state.id && state.source) {
			delete state.q;
			delete state.ds;
		}

		const port = location.port ? `:${location.port}` : "";
		// jazyk prijde pri != cs do BASE_URL, ale navic se pri ne cestine vygeneruje i do serialize
		let url = `https://${CONFIG.BASE_URL + (this._data.url ? this._data.url.substring(this._data.url.lastIndexOf("/")) : history.serialize(state).replace(/^[/][a-z]{2}[/]/u, "/"))}&frame=1`;

		if (options.previewMap && options.previewMap !== 0) {
			url += `&om=${options.previewMap}`;
		}

		if (options.labels && options.labels !== 0) {
			url += `&ol=${options.labels}`;
		}

		Mapy.Util.getShortLink(url).then(data => {
			this._shortFrameURL = `https://${CONFIG.BASE_DOMAIN}/s/${data.id}`;
			if (!dontActivate) {
				this._setActive();
			}
			this._frame.link = this._shortFrameURL;
		}, () => {});
	}

	/**
	 * Poslani signalu - otevreni, zavreni editace, nastaveni slozky.
	 *
	 * @param  {String} name Nazev signalu
	 * @param  {Object} data Vlastni data
	 */
	_sendSignal(name, data) {
		if (typeof this._cb === "function") {
			this._cb({
				name,
				...data,
			});
		}
	}

	/**
	 * Eventy z popup okna.
	 *
	 * @param  {Object} data Klice name atd.
	 */
	_popupEvent(data) {
		switch (data.name) {
			case "close":
				if (this._data.customCloseLog && this._data.type !== "folder") {
					const logger = Mapy.getComponent("logger");
					let dataLog = { text: "" };

					if (this._dom.shared.inputShare.checked) {
						dataLog = { text: "sdílet", type: this._data.type, origin: "my_maps" };
					}
					logger.log("click", {
						...dataLog,
						...this._data.analytics ? this._data.analytics : {},
					});
				}
				this._sendSignal("popup-close", {
					public: this._dom.shared.inputShare.checked,
				});
				if (this._data.public && this._data.like) {
					const logData = {};

					logData.text = "sdílet";
					logData.origin = "my_maps";
					logData.type = this._data.type;

					if (this._data.type === "entity") {
						logData.id = this._data.source_id || "";
						logData.name = this._data.title || "";
						logData.source = this._data.source || "";
					}
					Mapy.getComponent("logger").log("click", {
						...logData,
						...this._data.analytics ? this._data.analytics : {},
					});
				}
				if (this._shared || (this._data.public && this._data.like)) {
					this._shared = false;
					this._logSpecialData();
				}
				break;

			default:
				break;
		}
	}

	/**
	 * Zaloguje speciální data
	 */
	_logSpecialData() {
		switch (this._data.type) {
			case "measure":
				if ("measureLogData" in this._data) {
					Mapy.getComponent("logger").log("measure", this._data.measureLogData);
				}
				break;

			case "set":
				if ("usermarksLogData" in this._data) {
					Mapy.getComponent("logger").log("points", this._data.usermarksLogData);
				}
				break;

			default:
				break;
		}
	}

	/**
	 * přepínaní sdílení při varování o nemožnosti sdílení
	 */
	_switchShare() {
		if (this._dom.shared.warningSw.classList.contains("show")) {
			this._share.showHide(false);
			this._frame.showHide(false);
			this._popup.getContainer().removeAttribute("style");
			this._dom.shared.warningSw.classList.remove("show");
		} else {
			this._share.showHide(true);
			this._frame.showHide(true);

			this._dom.shared.warningSw.classList.add("show");
		}
	}

	/**
	 * Nastaví nápovědný text pro sdílenou položku
	 */
	_setHint() {
		this._dom.shared.hint.textContent = this._activeTab === "share" ? _("mymap.share.hint", { type: _(`mymap.share.${this._titleType}`) }) : _(`action.frame.${this._titleType === "folder" ? "folder" : "other"}.hint`, { type: _(`mymap.share.${this._titleType}`) });
	}
}
